import Area from '@/models/Area';
import LessonProgressDashboardStats, {
  LessonProgressDashboard,
} from '@/models/LessonProgressDashboardStats';
import { LessonNameFormatter } from '@/utils/lesson/nameFormatterFactory';
import { formatUnitNamePrefix } from '@/utils/unit/name';

export const COURSE_TRACK_PAGE_SIZE = 10;

export type CourseTrackLesson = {
  lessonId: number;
  title: string;
  description: string;
  bannerImg?: string;
  areas: Pick<Area, 'id' | 'name'>[];
};

const formatTitle = (
  lesson: LessonProgressDashboard,
  { formatName }: LessonNameFormatter,
) => {
  const lessonName = formatName(lesson);

  return lesson.lessonBlock
    ? `${formatUnitNamePrefix({
        unitOrder: lesson.lessonBlock.order,
      })} — ${lessonName}`
    : lessonName;
};

export const toCourseTrackLesson = (
  { lesson }: LessonProgressDashboardStats,
  lessonNameFormatter: LessonNameFormatter,
): CourseTrackLesson => ({
  lessonId: lesson.id,
  title: formatTitle(lesson, lessonNameFormatter),
  description: lesson.description,
  bannerImg: lesson.bannerImg,
  areas: lesson.areas,
});
